module.exports = __webpack_public_path__ + "img/security-audit-img-4.ab91f526.png";